<template>
  <section class="mt-5">
    <h2>ショッピングクラブ会員登録申込</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li class="here">申込入力</li>
        <li>内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <h3>ショッピングクラブ会員登録申込フォーム</h3>
      <p>
        ご自身のメールアドレスをご入力のうえ、「確認画面へ進む」を押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <form>
            <dl>
              <dt>メールアドレス</dt>
              <dd>
                <input
                  type="email"
                  class="input-w60"
                  style="ime-mode: disabled"
                  v-model="mail"
                  ref="mail"
                />
              </dd>
            </dl>
            <div class="border-bottom border-left border-right px-4 py-4">
              <p class="py-3">
                重要事項に同意いただける方は「同意する」にチェックを入れて確認画面へお進みください。
              </p>
              <p class="text-center"><strong>重要事項</strong></p>
              <p class="my-5">&#9312;マナビス・ショッピング・クラブ会員規約<span class="ml-5">（ダウンロードは<a href="/web/assets/pdf/shopping_application-1.pdf">こちら）</a></span></p>
              <embed src="/web/assets/pdf/shopping_application-1.pdf" type="application/pdf" width="100%" height="250px" class="only_pc">
              <div class="only_sp" style="width: 100%; height: 500px; overflow: scroll;">
                <img src="@/assets/img/shopping_application_1-1.jpg">
                <img src="@/assets/img/shopping_application_2-1.jpg">
                <img src="@/assets/img/shopping_application_3-1.jpg">
                <img src="@/assets/img/shopping_application_4-1.jpg">
              </div>
              <p class="text-center mt-5">
                <label for="consent1"
                  ><input
                    id="consent1"
                    type="checkbox"
                    class="check-02"
                    v-model="check1"
                    ref="check1"
                  /><strong>同意する</strong></label
                >
              </p>
              <p class="my-5">&#9313;個人情報保護方針<span class="ml-5">（ダウンロードは<a href="/web/assets/pdf/personal_info-1.pdf">こちら）</a></span></p>
              <embed src="/web/assets/pdf/personal_info-1.pdf" type="application/pdf" width="100%" height="250px" class="only_pc">
              <div class="only_sp" style="width: 100%; height: 500px; overflow: scroll;">
                <img src="@/assets/img/personal_info-1.jpg">
              </div>
              <p class="text-center mt-5">
                <label for="consent2"
                  ><input
                    id="consent2"
                    type="checkbox"
                    class="check-02"
                    v-model="check2"
                    ref="check2"
                  /><strong>同意する</strong></label
                >
              </p>
              <p class="my-5">&#9314;マナビス・ショッピング・クラブ会員登録の条件</p>
              <ul style="list-style: initial; padding-left: 5rem">
                <li>
                  申請者は、紹介者からマナビス・ショッピング会員の説明を受けています。
                </li>
                <li>申請者は、本人名で申請します。</li>
                <li>
                  配偶者は、メンバーズ会員やショッピング会員ではありません。
                </li>
                <li>申請者は、１８歳以上です。</li>
                <li>ショッピング会員は、商品の販売はできません。</li>
                <li>ショッピング会員は、紹介活動はできません。</li>
                <li>ショッピング会員は、コミッションを獲得できません。</li>
              </ul>
              <p class="text-center mt-5">
                <label for="consent3"
                  ><input
                    id="consent3"
                    type="checkbox"
                    class="check-02"
                    v-model="check3"
                    ref="check3"
                  /><strong>同意する</strong></label
                >
              </p>
            </div>
            <div class="box-p-20 text-center">
              <button
                v-on:click="putData"
                id="btnConfirm"
                type="button"
                class="confirm-01"
              >
                確認画面へ進む
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>

<script>
import utl from "@/modules/Utl";
import Message from "@/modules/Message";
import Request from "@/modules/Request";
import Authenticate from "@/modules/Authenticate";
import Store from "@/modules/Store";
let store = new Store();
let auth = new Authenticate();
let request = new Request();

export default {
  mounted() {
    this.getSession();
    this.mail = store.get("serialMail");
    window.scroll(0, 0);
  },
  data() {
    return {
      mail: "",
      check1: false,
      check2: false,
      check3: false,
    };
  },
  methods: {
    getSession() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data)
          if (auth.getNoLoginUid() == "") {
            console.log('setNoLoginUid')
            auth.setNoLoginUid(data.uux);
          }
          this.getData();
        });
    },
    putData() {
      if (!this.chkMailAddress()) return;
      store.set("serialMail", this.mail);
      if (!this.chkCheck1()) return;
      if (!this.chkCheck2()) return;
      if (!this.chkCheck3()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putSerialNoForShopping",
        [this.mail],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
            });
          } else {
            this.$router.push("/shopping/serial/confirm");
          }
        });
    },
    chkMailAddress() {
      let mes = utl.chkMustInput("メールアドレス", this.mail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.mail.focus();
          },
        });
        return false;
      }
      mes = utl.chkMailAddress("メールアドレス", this.mail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.mail.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkCheck1() {
      if (this.check1 != true) {
        Message.error().fire({
          title:
            "マナビス・ショッピング会員規約に同意頂ける方は「同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.check1.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkCheck2() {
      if (this.check2 != true) {
        Message.error().fire({
          title:
            "個人情報保護方針に同意頂ける方は「同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.check2.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkCheck3() {
      if (this.check3 != true) {
        Message.error().fire({
          title:
            "マナビス・ショッピング会員登録の条件に同意頂ける方は「同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.check3.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>
